import { mount } from '@kitup/web-core';
import { createEn } from '@kitup/web-core/i18n/en';
import { createRu } from '@kitup/web-core/i18n/ru';
import { brand } from '@kitup/brand-mylore';
import { legal } from '@kitup/brand-mylore/legal';
import { storefront } from '@kitup/brand-mylore/storefront';

/**
 * "MyLore" serves the UI in Russian and English.
 *
 * The legal bundle and the storefront come from their own entry points: both
 * are JSX, and the brand root is kept plain data so the API can import it
 * without React.
 */
mount(brand, legal, storefront, { ru: createRu, en: createEn });
